import React, {useEffect} from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {translations} from 'presentation/translations-new';
import {getPageHeaderTitle} from 'presentation/utils';
import {Navigate, useLocation} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';

import {useOperationalCostStore} from 'presentation/hooks/useOperationalCostPassword/store';
import {PATH_TITLE} from './constants';
import {useAccountInformation} from '../hooks';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';
import {useCongenereEligibilityStore} from '../store/useCongenereEligibilityStore';

const {booking} = translations['pt-br'].others.sidebar;

export function BookingWrapper() {
	const pageTitle = getPageHeaderTitle({internalPaths: PATH_TITLE, mainPath: booking});
	const {canOpenService, serviceTypeByPath} = useServicePermission();
	const {pathname} = useLocation();
	const isOperationalCostAuthorizated = useOperationalCostStore(
		state => state.isOperationalCostAuthorized,
	);
	const setRegisterLater = useFacialBiometricsStore(state => state.setRegisterLater);
	const serviceType = serviceTypeByPath(pathname);
	const {isValid, isContractSuspended} = useContractStatus();
	const {isResponsibleWithoutBenefits, isEarlyAccess} = useAccountInformation();
	const {congenereEligibility} = useCongenereEligibilityStore();

	const canAccessBookingService =
		isValid &&
		!isContractSuspended &&
		!isResponsibleWithoutBenefits &&
		!isEarlyAccess &&
		!congenereEligibility;

	useEffect(() => {
		return () => {
			setRegisterLater(false);
		};
	}, []);

	useEffect(() => {
		if (!canAccessBookingService) return;
		if (!isOperationalCostAuthorizated) {
			canOpenService(serviceType);
		}
	}, [pathname, isOperationalCostAuthorizated, serviceType]);

	if (!canAccessBookingService) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperLayout title={pageTitle} />;
}
